import { Middleware, Store } from 'redux';
import logger from '../../utils/logger';
import { State } from '../state';

const crashReporter: Middleware = (_store: Store<State>) => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    // Log and swallow — do not set a sticky global error that blanks every route
    // (including Profile) after a single reducer/mapState crash.
    logger.error(error);
    return undefined;
  }
};

export default crashReporter;
